import { render } from "./codeEditor.vue?vue&type=template&id=8f8c3af0"
import script from "./codeEditor.vue?vue&type=script&lang=js"
export * from "./codeEditor.vue?vue&type=script&lang=js"

import "./codeEditor.vue?vue&type=style&index=0&id=8f8c3af0&lang=scss"

import exportComponent from "D:\\alicode\\alicom-hall\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__